// extracted by mini-css-extract-plugin
export default {"container":"Progress_container__uZHHW","label":"Progress_label__GB40f","percentage":"Progress_percentage__hnFci"};